<template>
	<div class="tableDataClass">
		<div v-if="!inforFlag">
			<span class="moonClass">我的样品数据展示</span>
			<div class="searchDivClass">
				<div class="sampleEditClass">
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品编号</span>
						</div>

						<el-input v-model="queryParams.orderNo" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">使用单位名称</span>
						</div>
						<el-input v-model="queryParams.companyName" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品特征</span>
						</div>
						<el-input v-model="queryParams.content" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">使用方式</span>
						</div>
						<el-select v-model="queryParams.useType" clearable placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
						<!-- <el-input v-model="queryParams.status" clearable></el-input> -->
					</div>

					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">使用时间</span>
						</div>
						<el-date-picker clearable v-model="queryParams.useStartTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择开始使用时间"> </el-date-picker>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">返还时间</span>
						</div>
						<el-date-picker clearable v-model="queryParams.actualReturnTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择实际返还时间"> </el-date-picker>
					</div>
				</div>
				<el-button class="btnClass" @click="searchSampleFunc()"> <i class="el-icon-check"></i>确定</el-button>
			</div>

			<el-table :data="moonSampleTableData" stripe :height="500" style="width: 100%">
				<el-table-column type="index" width="50" align="center"></el-table-column>
				<el-table-column label="样品编号" width="220">
					<template slot-scope="scope">
						<div :title="scope.row.orderNo" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
							{{ scope.row.orderNo }}
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column label="样品类型">
                    <template slot-scope="scope">
                        {{ scope.row.sampleCategory1 + '/' + scope.row.sampleCategory2 + '/' + scope.row.sampleCategory3 + '/' + scope.row.sampleCategory4 }}
                    </template>
                </el-table-column> -->
				<el-table-column prop="borrowWeight" label="借用质量(mg)" width="120"> </el-table-column>
				<el-table-column prop="expectedConsumption" label="预期消耗量(mg)" width="130"> </el-table-column>
				<el-table-column prop="returnWeight" label="返回质量(mg)" width="120"> </el-table-column>
				<el-table-column label="样本照片">
					<template slot-scope="scope">
						<img v-if="scope.row.images && scope.row.images[0]" style="width: 44px; height: 44px" :src="scope.row.images[0].image" />
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column prop="companyName" label="使用单位" align="center"> </el-table-column>
				<el-table-column prop="usePerson" label="使用责任人" width="100" align="center"> </el-table-column>
				<el-table-column prop="useStartTime" width="130" label="开始使用时间" align="left"></el-table-column>
				<el-table-column prop="useEndTime" width="130" label="结束使用时间" align="left"></el-table-column>
				<el-table-column label="状态" align="center" prop="status">
					<template slot-scope="scope">
						<!-- 状态;0:待审核,1:审核通过,2:审核驳回,3:返还中,4:返还通过,5:返还失败,6:已终结 -->
						<!-- 0:分发审核中,1:待分发,2:审核驳回,3:返还检测中,4:检测通过,5:检测不通过,6:已终结,7:借用中 -->

						<span v-if="scope.row.status == 0">分发审核中</span>
						<span v-else-if="scope.row.status == 1">待分发</span>
						<span v-else-if="scope.row.status == 2">审核驳回</span>
						<span v-else-if="scope.row.status == 3">返还检测中</span>
						<span v-else-if="scope.row.status == 4">检测通过</span>
						<span v-else-if="scope.row.status == 5">检测不通过</span>
						<span v-else-if="scope.row.status == 7">借用中</span>
						<span v-else>已终结</span>
					</template>
				</el-table-column>
				<el-table-column label="使用方式"
					><template slot-scope="scope">
						<span v-if="scope.row.useType == 1">原样使用</span>
						<span v-else-if="scope.row.useType == 2">消耗使用</span>
						<span v-else-if="scope.row.useType == 3">破坏性使用</span>
						<span v-else-if="scope.row.useType == 4">展览教育科普</span>
						<span v-else-if="scope.row.useType == 5">赠送</span>
						<!-- <span v-else-if="scope.row.useType == 6">科普</span> -->
						<span v-else>其他</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<el-button @click="handleInforClick(scope.row)" type="text" size="small">详情</el-button>
						<el-button type="text" size="small" v-if="scope.row.status == 7" @click="returnSample(scope.row)">返还</el-button>
						<el-button type="text" size="small" v-if="scope.row.status == 7" @click="addDelayFunc(scope.row)">申请变更</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="block" style="background-color: #fff; height: 50px; display: flex; justify-content: end; align-items: center">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalMoonSample"
				>
				</el-pagination>
			</div>
		</div>
		<!-- 添加或修改订单返还信息对话框 -->
		<el-dialog title="返还申请表" :visible.sync="openDialog" width="50%" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
			<div>
				<el-form ref="returnRef" :model="form" :rules="rules" label-width="130px">
					<el-row>
						<el-col :span="12">
							<el-form-item label="样品编码" prop="orderNo">
								<el-input v-model="form.orderNo" :disabled="true" placeholder="请输入样品编码" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="借用质量(mg)" prop="borrowWeight">
								<el-input v-model="form.borrowWeight" :disabled="true" placeholder="请输入借用质量" />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="返还时间" prop="expectedReturnTime">
								<el-date-picker clearable v-model="form.expectedReturnTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择预计返还时间"> </el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="预期消耗量(mg)" prop="expectedConsumption">
								<el-input v-model="form.expectedConsumption" :disabled="true" placeholder="请输入预期消耗量" />
							</el-form-item>
							<!-- <el-form-item label="检测项目" prop="checkType">
								<el-select v-model="form.checkType" clearable placeholder="请选择">
									<el-option label="称重" value="1"> </el-option>
									<el-option label="外观检查" value="2"> </el-option>
								</el-select>
							</el-form-item> -->
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="实际消耗量(mg)" prop="actualConsumption">
								<el-input v-model="form.actualConsumption" placeholder="请输入实际消耗量" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="样品返还质量(mg)" prop="returnWeight">
								<el-input v-model="form.returnWeight" :disabled="true" placeholder="请输入样品返还质量" />
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div>
				<span class="spanInfor" style="color: #3a8ee6; height: 30px; display: block">请在下方对应上传样品返还配套资料</span>
				<el-form ref="recordRef" :model="formRecord" :rules="rules" label-width="150px">
					<!-- <el-form-item label="样品编号" prop="code">
						<el-input v-model="formRecord.code" :disabled="true" placeholder="请输入样品编号" />
					</el-form-item> -->
					<el-form-item label="样品使用报告" required prop="sampleReturnUseReport">
						<div style="display: flex">
							<el-input v-model="formRecord.sampleReturnUseReport" :disabled="true" clearable />
							<el-upload class="upload-demo" :headers="headers" :action="`${actionUrl}/common/upload`" :on-success="handleSuccessReturnUseReport" multiple>
								<el-button size="small" type="primary">点击上传</el-button>
								<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
							</el-upload>
						</div>
					</el-form-item>
					<el-form-item label="样品测试与分析数据" required prop="sampleReturnAnalysisData">
						<div style="display: flex">
							<el-input v-model="formRecord.sampleReturnAnalysisData" :disabled="true" clearable />
							<el-upload class="upload-demo" :headers="headers" :action="`${actionUrl}/common/upload`" :on-success="handleSuccessRecordAnalysisData" multiple>
								<el-button size="small" type="primary">点击上传</el-button>
							</el-upload>
						</div>
					</el-form-item>
					<el-form-item label="样品使用过程记录" prop="sampleReturnUseRecord">
						<div style="display: flex">
							<el-input v-model="formRecord.sampleReturnUseRecord" placeholder="上传文件大小不超过500M！" :disabled="true" clearable />
							<el-upload class="upload-demo" :headers="headers" :action="`${actionUrl}/common/upload`" :on-success="handleSuccessReturnCheck" :before-upload="beforeUpload" multiple>
								<el-button size="small" type="primary">点击上传</el-button>
							</el-upload>
						</div>
					</el-form-item>
					<el-form-item label="样品归还申请表" required prop="sampleReturnApplication">
						<div style="display: flex">
							<el-input v-model="formRecord.sampleReturnApplication" :disabled="true" clearable />
							<el-upload class="upload-demo" :headers="headers" :action="`${actionUrl}/common/upload`" :on-success="handleReturnApplication">
								<el-button size="small" type="primary">点击上传</el-button>
							</el-upload>
						</div>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input v-model="form.remark" type="textarea" :rows="4" placeholder="请输入备注" />
					</el-form-item>
				</el-form>
			</div>
			<template #footer>
				<div class="dialog-footer">
					<el-button type="primary" @click="submitForm">提 交</el-button>
				</div>
			</template>
		</el-dialog>

		<el-dialog title="详情" :visible.sync="openOrderDialog" width="50%" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
			<el-descriptions title="订单信息" direction="vertical" :column="4" border>
				<el-descriptions-item label="借用样品id">{{ formOrder.sampleDataId }}</el-descriptions-item>
				<el-descriptions-item label="订单编号">{{ formOrder.orderNo }}</el-descriptions-item>
				<el-descriptions-item label="使用方式">{{ formOrder.useType }}</el-descriptions-item>

				<el-descriptions-item label="使用单位名称">{{ formOrder.companyName }}</el-descriptions-item>
				<el-descriptions-item label="使用单位法人">{{ formOrder.legalPerson }}</el-descriptions-item>
				<el-descriptions-item label="法人身份证号">{{ formOrder.legalPersonId }}</el-descriptions-item>
				<el-descriptions-item label="法人联系电话">{{ formOrder.legalPersonTel }}</el-descriptions-item>
				<el-descriptions-item label="法人电子邮箱">{{ formOrder.legalPersonEmail }}</el-descriptions-item>
				<el-descriptions-item label="使用责任人">{{ formOrder.usePerson }}</el-descriptions-item>
				<el-descriptions-item label="责任人身份证号">{{ formOrder.usePersonId }}</el-descriptions-item>
				<el-descriptions-item label="责任人联系电话">{{ formOrder.usePersonTel }}</el-descriptions-item>
				<el-descriptions-item label="责任人电子邮箱">{{ formOrder.usePersonEmail }}</el-descriptions-item>

				<el-descriptions-item label="预计返还时间">{{ formOrder.expectedReturnTime }}</el-descriptions-item>
				<el-descriptions-item label="实际返还时间">{{ formOrder.actualReturnTime }}</el-descriptions-item>

				<el-descriptions-item label="样品借用质量">{{ formOrder.borrowWeight }}</el-descriptions-item>
				<el-descriptions-item label="样品返还质量">{{ formOrder.returnWeight }}</el-descriptions-item>

				<el-descriptions-item label="预期消耗量">{{ formOrder.expectedConsumption }}</el-descriptions-item>
				<el-descriptions-item label="实际消耗量">{{ formOrder.actualConsumption }}</el-descriptions-item>

				<el-descriptions-item label="开始使用时间">{{ formOrder.useStartTime }}</el-descriptions-item>
				<el-descriptions-item label="结束使用时间">{{ formOrder.useEndTime }}</el-descriptions-item>

				<el-descriptions-item label="借用审核员">{{ formOrder.borrowReview }}</el-descriptions-item>
				<el-descriptions-item label="借用审核时间">{{ formOrder.borrowReviewTime }}</el-descriptions-item>
				<el-descriptions-item label="返还审核员">{{ formOrder.returnReview }}</el-descriptions-item>
				<el-descriptions-item label="返还审核时间">{{ formOrder.returnReviewTime }}</el-descriptions-item>
				<el-descriptions-item label="借用审核失败原因">{{ formOrder.borrowReviewReason }}</el-descriptions-item>
			</el-descriptions>
		</el-dialog>
		<el-dialog title="变更申请" :visible.sync="delayDialog" width="50%" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
			<el-form ref="formDelayRef" :model="formDelay" :rules="rules" label-width="130px">
				<el-form-item label="订单id" prop="orderId">
					<el-input v-model="formDelay.orderId" :disabled="true" />
				</el-form-item>
				<el-form-item label="订单编号" prop="code">
					<el-input v-model="formDelay.code" :disabled="true" />
				</el-form-item>
				<el-form-item label="预计变更消耗量" prop="changeleight">
					<el-input v-model="formDelay.changeleight" />
				</el-form-item>
				<el-form-item label="预计变更返还日期" prop="delayReturnTime">
					<el-date-picker v-model="formDelay.delayReturnTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
				</el-form-item>
				<!-- <el-form-item label="延期原因" prop="delayRejectedReason">
					<el-input v-model="formDelay.delayRejectedReason" type="textarea" :rows="2" placeholder="请输入延期原因" />
				</el-form-item> -->
				<el-form-item label="变更申请表" prop="filePath">
					<div style="display: flex">
						<el-input v-model="formDelay.filePath" required :disabled="true" clearable></el-input>
						<el-upload class="upload-demo" :headers="headers" :action="`${actionUrl}/common/upload`" :on-success="handleSuccessChange" :before-upload="beforeUpload">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitDelayFunc">确 定</el-button>
			</span>
		</el-dialog>
		<sampleInfor v-show="inforFlag" ref="sampleInfoRef" @goBackFunc="goBackFunc"></sampleInfor>
	</div>
</template>

<script>
import cookie from '../../../utils/cookie'
import sampleInfor from './mySampleInfor.vue'
// 、
export default {
	components: {
		sampleInfor
	},
	data() {
		return {
			formDelay: {
				// delayRejectedReason: '',
				orderId: '',
				code: '',
				delayReturnTime: '',
				filePath: '',
				changeleight: ''
			},

			delayDialog: false,
			inforFlag: false,
			formRecord: {
				sampleOrderId: null,
				code: null,
				sampleReturnUseRecord: null,
				sampleReturnAnalysisData: null,
				sampleReturnUseReport: null,
				sampleReturnApplication: null
			},
			options: [
				{
					value: '1',
					label: '原样使用'
				},
				{
					value: '2',
					label: '消耗使用'
				},
				{
					value: '3',
					label: '破坏性使用'
				},
				{
					value: '4',
					label: '展览'
				},
				{
					value: '5',
					label: '教育'
				},
				{
					value: '6',
					label: '科普'
				},
				{
					value: '7',
					label: '其他'
				}
			],
			actionUrl: window.dataManage.proPrefix,
			openOrderDialog: false,
			formOrder: {
				sampleDataId: null,
				useType: null,
				orderNo: null,
				companyName: null,
				legalPerson: null,
				legalPersonId: null,
				legalPersonTel: null,
				legalPersonEmail: null,
				usePerson: null,
				usePersonId: null,
				usePersonTel: null,
				usePersonEmail: null,
				expectedReturnTime: null,
				actualReturnTime: null,
				borrowWeight: null,
				returnWeight: null,
				expectedConsumption: null,
				actualConsumption: null,
				useStartTime: null,
				useEndTime: null,
				status: null,
				borrowReview: null,
				borrowReviewReason: null,
				borrowReviewTime: null,
				returnReview: null,
				returnReviewTime: null,
				returnReviewReason: null
			},
			queryParams: {
				orderNo: '',
				companyName: '',
				useType: '',
				usePerson: '',
				status: '',
				useStartTime: '',
				actualReturnTime: ''
			},
			headers: {},
			importData: { imporType: 1 },
			authorization: '',
			form: {
				orderNo: null,
				sampleOrderId: null,
				sampleReturnApplication: null,
				sampleReturnCheck: null,
				checkType: null,
				sampleReturnCheckReport: null,
				sampleReturnAnalysisData: null,
				actualConsumption: null,
				returnWeight: null,
				useStartTime: null,
				borrowWeight: null,
				expectedConsumption: null,
				useEndTime: null,
				remark: null
			},
			rules: {},
			openDialog: false,
			moonSampleTableData: [],
			currentPage: 1,
			pageSize: 10,
			totalMoonSample: 0
		}
	},
	watch: {
		// 监听单个属性
		'form.actualConsumption': {
			handler(newVal, oldVal) {
				console.log(newVal)
				this.form.returnWeight = this.form.borrowWeight - newVal
			},
			immediate: true
		}
	},
	mounted() {
		this.authorization = this.$cookie.get('PIE_MALL_Token')
		this.headers = { Authorization: this.authorization }
		this.mySampleInit()
	},
	methods: {
		// 延期申请
		addDelayFunc(row) {
			this.delayDialog = true
			this.formDelay = {
				orderId: row.id,
				code: row.orderNo,
				delayReturnTime: null,
				changeleight: null,
				filePath: null
			}
		},
		handleSuccessChange(response, file, fileList) {
			this.formDelay.filePath = response.fileName
		},
		async submitDelayFunc() {
			if (this.formDelay.changeleight == '') {
				this.formDelay.changeleight = null
			}
			console.log(this.formDelay)
			let res = await this.$http.post(this.$const.moonSample.addDelay, this.formDelay)
			if (res && res.code == 200) {
				this.delayDialog = false
				this.$message.success('延期申请成功！')
			}
		},
		goBackFunc() {
			this.inforFlag = false
		},
		returnFunc() {
			if (this.active >= 1) {
				this.active--
			}
			if (this.active == 0) {
				this.$nextTick(() => {
					let formObj = this.addBorrowForm
					formObj.id = this.addBorrowForm.sampleDataId
					formObj.code = this.addBorrowForm.orderNo
					this.addBorrowForm = this.$refs.addFormInit.initForm(formObj)
				})
			} else if (this.active == 1) {
				this.$nextTick(() => {
					this.$refs.addMySampleBorrow.borrowInit(this.addBorrowForm)
				})
			}
		},

		objDataFunc(row) {
			console.log(this.formOrder)
			console.log(row)
		},

		handleInforClick(row) {
			this.inforFlag = true
			this.$nextTick(() => {
				this.$refs.sampleInfoRef.initDataFunc(row)
			})

			// this.objDataFunc(row)
			// this.openOrderDialog = true
			// this.formOrder = row
			// this.form.sampleOrderId = item.id
		},

		async searchSampleFunc() {
			const params = {
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				createBy: this.$cookie.get('userCreateBy')
			}

			if (this.queryParams.orderNo !== '') params.orderNo = this.queryParams.orderNo
			if (this.queryParams.companyName !== '') params.companyName = this.queryParams.companyName
			if (this.queryParams.useType !== '') params.useType = this.queryParams.useType
			if (this.queryParams.usePerson !== '') params.usePerson = this.queryParams.usePerson
			if (this.queryParams.status !== '') params.status = this.queryParams.status
			if (this.queryParams.useStartTime !== '') params.useStartTime = this.queryParams.useStartTime
			if (this.queryParams.actualReturnTime !== '') params.actualReturnTime = this.queryParams.actualReturnTime

			let res = await this.$http.get(this.$const.moonSample.getMoonSampleBorrowingReturn, params)
			if (res && res.code == 200) {
				this.moonSampleTableData = res.rows
				this.totalMoonSample = res.total
			}
		},

		handleSuccess(response) {
			if (response.responseCode == 0) {
				this.$message.success(response.responseMsg)
			} else {
				this.$message.error(response.responseMsg)
			}
		},
		handleSuccessRecordFilePath(response, file, fileList) {
			this.formRecord.filePath = response.fileName
		},
		handleSuccessReturnUseReport(response, file, fileList) {
			this.formRecord.sampleReturnUseReport = response.fileName
		},
		handleSuccessRecordAnalysisData(response, file, fileList) {
			this.formRecord.sampleReturnAnalysisData = response.fileName
		},
		handleSuccessReturnCheck(response, file, fileList) {
			this.formRecord.sampleReturnUseRecord = response.fileName
		},

		handleReturnApplication(response, file, fileList) {
			this.formRecord.sampleReturnApplication = response.fileName
		},
		beforeUpload(file) {
			// const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
			const isLt2M = file.size / 1024 / 1024 < 500 // 文件大小限制为500M

			// if (!isJPGOrPNG) {
			// 	this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
			// 	return false
			// }
			if (!isLt2M) {
				this.$message.error('上传文件/视频大小不能超过 500M!')
				return false
			}
			return true // 返回 true 表示允许上传。
		},
		returnSample(item) {
			this.active = 0
			this.orderForm = item
			this.form = item
			this.form.sampleOrderId = item.id
			this.formRecord.sampleOrderId = item.id
			this.formRecord.code = item.orderNo
			this.openDialog = true
		},
		async addReturnFunc() {
			console.log(this.form)
			let resReturn = await this.$http.post(this.$const.moonSample.addReturn, this.form)
			console.log(resReturn)
		},
		// 使用记录
		async addRecordFunc() {
			console.log(this.formRecord)
			let res = await this.$http.post(this.$const.moonSample.addReturn, this.formRecord)
			if (res && res.code == 200) {
				console.log(res.data)
				this.$refs[`recordRef`].resetFields()
			}
		},

		async submitForm() {
			this.orderForm.status = 3
			this.orderForm.action = 'UserReturn'

			this.orderForm.actualConsumption = this.form.actualConsumption
			this.orderForm.returnWeight = this.form.returnWeight
			this.orderForm.useStartTime = this.form.useStartTime
			this.orderForm.useEndTime = this.form.useEndTime
			this.orderForm.remark = this.form.remark
			let newForm = {
				...this.orderForm,
				sampleOrderId: this.form.sampleOrderId,
				// sampleReturnApplication: this.form.sampleReturnApplication,
				// sampleReturnCheck: this.form.sampleReturnCheck,
				// sampleReturnCheckReport: this.form.sampleReturnCheckReport,
				// sampleReturnAnalysisData: this.form.sampleReturnAnalysisData,
				checkType: this.form.checkType,
				...this.formRecord
			}
			console.log(newForm)
			let res = await this.$http.put(this.$const.moonSample.updateOrder, newForm)
			if (res && res.code == 200) {
				this.openDialog = false
				this.addRecordFunc()
				// this.addReturnFunc()
				this.mySampleInit()
				this.$message.success('申请成功！')
			}
		},
		async mySampleInit() {
			if (!this.$store.state.user.isLogin || !this.$cookie.get('userCreateBy')) {
				alert('请登录用户！')
				return
			}
			const param = {
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				createBy: this.$cookie.get('userCreateBy')
			}
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleBorrowingReturn, param)
			if (res && res.code == 200) {
				this.moonSampleTableData = res.rows
				this.totalMoonSample = res.total
			}
		},
		handleCurrentChange(val) {
			this.currentPage = val
			this.mySampleInit()
		},
		handleSizeChange(val) {
			this.pageSize = val
			this.mySampleInit()
		},
		async getMoonSampleBorrowingReturnFunc() {
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleBorrowingReturn)
			if (res && res.code == 200) {
				this.moonSampleTableData = res.data
			}
		},
		async addMoonSampleBorrowingReturnFunc(item) {
			// let res = await this.$http.post(this.$const.moonSample.addMoonSampleBorrowingReturn, item);
			// if (res && res.code==200) {
			// 	this.totalCount = res.data
			// }
		}
	}
}
</script>

<style lang="scss" scoped>
.tableDataClass {
	// width: 100%;
	width: 1200px;
	.moonClass {
		font-size: 28px;
		color: #000000;
		display: block;
		text-align: left;
		margin-top: 30px;
		margin-bottom: 30px;
	}
	.searchDivClass {
		text-align: center;
		background: #ffffff;
		border-radius: 4px;
		border: 1px solid rgba(21, 65, 140, 0.2);
		margin-bottom: 22px;
		padding: 10px;
		.el-date-editor.el-input,
		.el-date-editor.el-input__inner {
			width: auto;
		}
		.titleNameClass {
			display: flex;
			justify-content: left;
			align-items: center;
			height: 30px;
			padding: 5px;
			.lineClass {
				width: 2px;
				height: 16px;
				background: #15418c;
			}
			.sampleTypeClass {
				height: 21px;
				font-family: MicrosoftYaHeiUISemibold;
				font-size: 16px;
				color: #000000;
				line-height: 21px;
				text-align: left;
				font-style: normal;
				display: block;
				margin-left: 8px;
			}
		}

		.sampleEditClass {
			display: flex;
			align-items: baseline;
			margin-top: 10px;
			justify-content: left;
			align-items: baseline;
			flex-wrap: wrap;
			.sampleNum {
				width: 280px;
				margin: 6px;
				display: flex;
				flex-direction: column;
				.sampleNumTitleClass {
					display: flex;
					align-items: center;
					margin-bottom: 8px;
					.lineClass {
						width: 2px;
						height: 16px;
						background: #15418c;
					}
					.sampleNumClass {
						height: 21px;
						font-family: MicrosoftYaHeiUISemibold;
						font-size: 16px;
						color: #000000;
						line-height: 21px;
						text-align: left;
						font-style: normal;
						display: block;
						margin-left: 8px;
					}
				}
			}
		}
		.inforNameClass {
			display: flex;
			justify-content: left;
			align-items: baseline;
			flex-wrap: wrap;
			.spanDivClass {
				display: flex;
				justify-content: stretch;
				-webkit-box-align: baseline;
				align-items: center;
				padding: 8px;
				width: 50%;
				height: 60px;
			}
			.nameClass {
				width: 50px;
				margin-right: 10px;
				height: 40px;
				font-family: MicrosoftYaHeiUI;
				font-size: 16px;
				color: #000000;
				line-height: 21px;
				text-align: left;
				font-style: normal;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			.typeClass2:hover,
			.typeClass1 {
				// width: 116px;
				min-width: 96px;
				padding-left: 10px;
				padding-right: 10px;
				max-width: max-content;
				margin-right: 5px;
				height: 40px;
				background: #15418c;
				border-radius: 4px;
				color: #ffffff;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			.typeClass2 {
				// width: 116px;
				height: 40px;
				min-width: 96px;
				padding-left: 10px;
				padding-right: 10px;
				max-width: max-content;
				margin-right: 5px;
				background: radial-gradient(396% 161% at 50% 0%, rgba(21, 65, 140, 0.3) 0%, rgba(21, 65, 140, 0) 100%);
				border-radius: 4px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}
		}
		.btnClass {
			background: #15418c;
			border-radius: 4px;

			font-family: MicrosoftYaHeiUI;
			font-size: 16px;
			color: #ffffff;
			line-height: 21px;
			text-align: left;
			font-style: normal;
			line-height: 10px;
			text-align: left;
			font-style: normal;
			margin-top: 5px;
		}
	}
}
</style>
<style>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
	width: 100%;
}
</style>